import { EnumClaseFactura, EnumCommodity, EnumEstadoFactura, EnumTipoFactura } from '../../api'
import { EnumClientTypes } from '../../api/Argentia/enums/enumClientTypes'
import { EnumCriticidad } from '../../api/oData/enums/enumCriticidad'
import { EnumDominioTarea } from '../../api/oData/enums/enumDominioTarea'
import { EnumEstadoTarea } from '../../api/oData/enums/enumEstadoTarea'
import { DataTableActionConfiguration, DateFilters, DatePeriod } from '../../model'

export enum TabsInvoicesType {
  finalClient = 6,
  extendedClient = 12,
  distribution = 3,
  commercial = 8,
  wholesaler = 1,
  shipper = 4,
  aggregatedInvoice_finalClient = 100,
  aggregatedInvoice_extendedClient = 101
}

export interface InvoicesTableModel {
  id: number
  emisionDate: Date
  registrationDate: Date
  class: EnumClaseFactura
  code: number
  contractCode?: string
  subject: string
  subjectSource: string
  cups: string
  startDate: Date
  endDate: Date
  amount: number
  invoiceType?: EnumTipoFactura | null
  settlementGroupCode?: string
  status: EnumEstadoFactura
  //objections: ObjectionTableModel[],
  url: string
  urlDistribution: string
  urlDocument: string
  // documentId: number
  lgManual: boolean
  actionsConfiguration?: Array<DataTableActionConfiguration>
  actions?: any
  hasObjections: boolean
  canManual: boolean
  showComplaint: boolean
  aggregatedInvoiceId?: number
  showDeliveryNotes: boolean
  showAggregatedInvoice: boolean
}

export interface ObjectionTableModel {
  id?: number
  idObjMaestra: number
  criticalityId: number
  description: string
  code?: string
  comments: string
  invoiceID: number
  documentID: number
  settlementID?: number
  settlementBatchID?: number
  state: EnumEstadoTarea
  canTerminate?: boolean
}

export interface ObjectionsModel {
  id: number
  idObjMaestra: number
  invoiceID: number
  settlementID: number
  settlementBatchID: number
  documentID: number
  description: string
  code: string
  comments: string
  type: EnumDominioTarea
  criticalityId: number
  criticality: EnumCriticidad
  taskTypeCode: string
  state: EnumEstadoTarea
}

export interface InvoiceFilterModel {
  startDate?: string
  endDate?: string
  invoiceType: EnumTipoFactura[]
  subjectType: EnumClientTypes
  balanceZone: number
  companyID: number
  commodity?: EnumCommodity
  contractCode?: string
  cupsCode?: string
  invoice?: string
  subject?: string
  lastRecords?: number
  filterDateBy?: FilterDateBy
  states?: number[]
  subjectId?: number
  hasObjections?: boolean | null
}

export type InvoiceFilterRequest = {
  commodity?: EnumCommodity
  clientType: EnumClientTypes
  dateRange: DatePeriod
  invoiceCode: string
  subjectCode: string
  contractCode?: string
  cupsCode?: string
  activeDateFilter?: DateFilters
  filterDateBy?: FilterDateBy
  invoiceStates?: EnumEstadoFactura[] | null
  activePageTab?: TabsInvoicesType | null
  subjectId?: number
  hasObjections?: boolean | null
}

export enum FilterDateBy {
  REGISTRATION = 1,
  EMISSION = 2
}
